import Logger from "./lib/Logger";
import Mastodon, { MastodonUnion } from "./lib/Mastodon";

// add Mastodon to window interface
declare global {
  interface Window {
    Mastodon: MastodonUnion;
    pbjs: any;
    googletag: any;
  }
}
Logger.hero();

const mastodon: Mastodon = new Mastodon();

if (window.Mastodon) {
  if (Array.isArray(window.Mastodon)) {
    const arr = [...window.Mastodon];
    Logger.log("processing existing queue");
    window.Mastodon = mastodon;
    mastodon.addExistingTasks(arr);
  }
}

window.Mastodon = mastodon;
